<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <view-responsibility>
        </view-responsibility> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import viewResponsibility from './todo-view-responsibility'
export default {
    components: {
        viewResponsibility
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-view-responsibility.vue